import React from 'react';
import Container from 'shared/container';
import Headline from 'shared/headline';
import Influencer from 'shared/person-card';

import styles from './grid.module.scss';

function GridGroup1({ title, influencers }) {
  return (
    <Container>
      <Headline h1 title html={title} />
      <div className={styles.gridWrapper}>
        {influencers.map((influencer, i) => (
          <div className={styles.cardWrapper} key={`${influencer.name}-${i}`}>
            <Influencer {...influencer} />
          </div>
        ))}
      </div>
    </Container>
  );
}
export default GridGroup1;
